// Library
import config from "config";
import {
  get,
  post
} from "../../infrastructure/processes-domain/simple/actions";

export const checkAuth = () => post(`${config.api}/api/Account/CheckAuth`);
